import { editDriver } from '../../../actions/siteadmin/editDriver';
import { api } from '../../../config';

async function submit(values, dispatch, props) {
    values.password = values.password ? values.password : undefined;
    
    // Get the initial status from the form's initial values
    const initialStatus = props?.initialValues?.userStatus;
    const newStatus = values?.userStatus;
    
    // Update the driver
    await dispatch(
        editDriver(
            values
        )
    );
    
    // Send approval notification if driver is being approved
    if (initialStatus !== 'active' && newStatus === 'active') {
        try {
            console.log('🎉 Driver approved! Sending notification to driver:', values.id);
            
            // Call the push notification endpoint
            const notificationPayload = {
                content: {
                    title: "🎉 Congratulations!",
                    message: "Your driver account has been approved! You can now start accepting ride requests and earn money.",
                    notificationType: "driver_approved"
                },
                userId: values.id,
                userType: 2 // Driver type
            };
            
            const response = await fetch(`${api.apiEndpoint}/push-notification`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(notificationPayload)
            });
            
            if (response.ok) {
                console.log('✅ Driver approval notification sent successfully');
            } else {
                console.error('❌ Failed to send driver approval notification');
            }
        } catch (error) {
            console.error('❌ Error sending driver approval notification:', error);
        }
    }
}

export default submit;